/* globals Vue */

import App from './App'

Vue.filter('number', function (val) {
	if (typeof val === 'number') {
		return val.toLocaleString()
	} else {
		return val
	}
})

init()

function init () {
	if (!isSupported()) return

	const rootE = document.querySelector('#js-maman-schedule-replace')
	if (!rootE) return

	const app = new Vue(App)
	app.$mount(rootE)
}

function isSupported () {
	if (typeof (1).toLocaleString !== 'function') {
		return false
	}
	if (typeof [].map !== 'function') {
		return false
	}
	if (!window.localStorage || !window.sessionStorage) {
		return false
	}
	return true
}
